import http from '../../http'
export default {
    add: (data) => {
        return http.post('activityservice/conncilhousemanage/save', data)
    },
    update: (data) => {
        return http.post('activityservice/conncilhousemanage/update', data)
    },
    del: (data) => {
        return http.post('activityservice/conncilhousemanage/remove', data)
    },
    list: (params) => {
        return http.get('activityservice/conncilhousemanage/list', params)
    },
}
